<ca-modal-container modalTitle="{{ 'MODULES.EDITOR.TITLE' | translate }}" (dismiss)="dismiss('Canceled')">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <input
                    type="text"
                    class="form-control"
                    id="title"
                    placeholder="Title"
                    formControlName="title"
                    required
                    data-uit="edit-module-title"
                    [ngClass]="formGroup.get('title')?.errors && formGroup.get('title')?.touched ? 'has-error' : ''"
                />
                <label for="title">{{ 'GENERAL.TITLE' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">
                {{ 'MODULES.CREATOR.ERROR_MODULE_TITLE' | translate }}
            </small>
            <small *ngIf="formGroup.get('title')?.touched && formGroup.get('title')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <textarea
                    class="form-control"
                    id="summary"
                    [placeholder]="'MODULES.EDITOR.SHORT_SUMMARY_PLACEHOLDER' | translate"
                    formControlName="summary"
                    [ngClass]="formGroup.get('summary')?.errors && formGroup.get('summary')?.touched ? 'has-error' : ''"
                ></textarea>
                <label for="summary">{{ 'MODULES.EDITOR.SHORT_SUMMARY_TITLE' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'MODULES.EDITOR.SUMMARY_TOO_LONG' | translate }}
            </small>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3 form-group">
            <div class="d-flex flex-column-reverse">
                <ca-quill-editor-wrapper
                    id="description"
                    formControlName="description"
                    [placeholder]="'MODULES.EDITOR.DESCRIPTION_PLACEHOLDER' | translate"
                    data-uit="module-metadata-modal-detailed-description-input"
                    [required]="true"
                    (touched)="onTouched()"
                    [ngClass]="description.touched && description.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>
                <label for="description">{{ 'MODULES.EDITOR.DESCRIPTION_TITLE' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="description.touched && description.errors?.maxLength" class="invalid-feedback">
                {{ 'MODULES.EDITOR.DESCRIPTION_TOO_LONG' | translate: { descriptionLengthLimit: descriptionLengthLimit } }}
            </small>
            <small *ngIf="description.touched && description.errors?.required" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="file-upload-panel mb-3">
            <div class="mb-2">
                <h4 class="title">{{ 'MODULES.EDITOR.IMAGE_AND_ICON_TITLE' | translate }}</h4>
                <span class="title-info">{{ 'MODULES.EDITOR.IMAGE_ICON_LONG' | translate }}</span>
            </div>
            <div class="wrap">
                <ca-file-upload
                    [blobType]="moduleImageBlobType"
                    [pathToAppend]="versionUnderEdit.id"
                    [maxInputSizeInBytes]="1024 * 1024"
                    [allowMultipleFiles]="false"
                    [uploaderKey]="'module_editor_upload'"
                    [supportedFileTypes]="supportedImageTypes"
                    (onUploadStarted)="handleStartUpload()"
                    (onUploadCompleted)="onUploadCompleted($event)"
                    (invalidFiles)="updateImageUrlState($event)"
                >
                </ca-file-upload>
                <div class="exist-item" *ngIf="formGroup.get('imageUrl')?.value" #fileItem>
                    <span class="file-name">{{ formGroup.get('imageUrl')?.value }}</span>
                    <button
                        type="button"
                        class="btn ca-btn-icon ca-btn-icon-small"
                        (click)="removeFileItem(fileItem)"
                        data-uit="edit-module-remove-uploaded-image"
                    >
                        <ca-icon name="cross" size="s"></ca-icon>
                    </button>
                </div>
                <input type="text" class="form-control" formControlName="imageUrl" hidden />
            </div>
            <small *ngIf="formGroup.get('imageUrl')?.hasError('maxFileSize')" class="invalid-feedback">
                {{ (formGroup.get('imageUrl')?.errors)['maxFileSize'] }}
            </small>
            <small *ngIf="formGroup.get('imageUrl')?.hasError('invalidImageType')" class="invalid-feedback">
                {{ (formGroup.get('imageUrl')?.errors)['invalidImageType'] }}
            </small>
        </div>
        <div class="mb-3 form-group">
            <div class="d-flex flex-column-reverse">
                <ng-select
                    data-uit="edit-module-category-selector"
                    formControlName="categoryId"
                    placeholder="Please select a category"
                    [clearable]="false"
                    [searchable]="false"
                    appendTo="body"
                    id="category"
                >
                    <ng-option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name | titlecase }}
                    </ng-option>
                </ng-select>
                <label for="category">{{ 'GENERAL.CATEGORY' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('categoryId')?.hasError('required') && formGroup.get('categoryId')?.touched" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <ca-input-checkbox formControlName="isFeatured" *ngIf="isEditingAsAdmin && module.latestPublicVersion" appendTo="body">
            {{ 'MODULES.EDITOR.FEATURED_MODULE' | translate }}
        </ca-input-checkbox>
        <div class="my-3" *ngIf="isEditingAsAdmin && module.latestPublicVersion">
            <span class="title-info">{{ 'MODULES.COMPLIANCE.MODULE_IS_COMPLIANT' | translate }} <span class="red">*</span></span>
            <div caGroup class="pt-2" [formControlName]="'isCompliant'">
                <ca-input-radio class="check" [name]="'isCompliant'" [value]="true"> {{ 'GENERAL.YES' | translate }}. </ca-input-radio>
                <ca-input-radio class="check" [name]="'isCompliant'" [value]="false"> {{ 'GENERAL.NO' | translate }}. </ca-input-radio>
            </div>
            <small *ngIf="formGroup.get('isCompliant')?.hasError('required') && formGroup.get('isCompliant')?.touched" class="invalid-feedback">
                {{ 'MODULES.COMPLIANCE.PLEASE_CHOOSE_ONE_OPTION' | translate }}
            </small>
        </div>
        <div class="modal-buttons">
            <button type="submit" caAutoFocus [disabled]="isSubmitting || formGroup.invalid" class="btn btn-primary" data-uit="edit-module-save-button">
                {{ 'GENERAL.SAVE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
